import { useState } from "react";
import TornFrame from "./TornFrame";
import videoThumb from "../../../pictures/Hero/officer-retreat.jpg";

const VIDEO_ID = "xvL1BpwOZwU";
const THUMB_BG = `url(${videoThumb})`;
const EMBED_SRC = `https://www.youtube.com/embed/${VIDEO_ID}?autoplay=1&rel=0&playsinline=1&origin=${encodeURIComponent(
  window.location.origin
)}`;
const WATCH_URL = `https://www.youtube.com/watch?v=${VIDEO_ID}`;

const Hero = () => {
  const [playing, setPlaying] = useState(false);

  return (
    <section className="board-hero">
      <div className="board-hero-circle" aria-hidden="true" />

      <div className="board-hero-title-wrap">
        <h1 className="board-hero-title">
          <span className="board-hero-title-our">Our</span>
          <span className="board-hero-title-year">2026-2027</span>
          <span className="board-hero-title-board">Board!</span>
        </h1>
      </div>

      <div className="board-hero-video-row">
        <TornFrame
          id="hero-video"
          rotate={-1}
          pointsPerEdge={22}
          jitter={1.2}
          className="board-hero-video-frame"
        >
          <div className="board-hero-video-box">
            {playing ? (
              <iframe
                src={EMBED_SRC}
                title="FASA Board video"
                referrerPolicy="strict-origin-when-cross-origin"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="board-hero-video-iframe"
              />
            ) : (
              <button
                type="button"
                aria-label="Play board video"
                className="board-hero-video-play"
                style={{ backgroundImage: THUMB_BG }}
                onClick={() => setPlaying(true)}
              >
                <span className="board-hero-video-play-btn">
                  <span className="board-hero-video-play-icon" />
                </span>
              </button>
            )}
          </div>
        </TornFrame>

        <TornFrame
          id="hero-label"
          rotate={0}
          pointsPerEdge={16}
          jitter={3}
          padding="0"
          background="#12201f"
          className="board-hero-label"
        >
          <div className="board-hero-label-inner">
            <span className="board-hero-label-title">Meet the Board</span>
            <span className="board-hero-label-body">
              Watch the Board introduce themselves!
            </span>
            <a
              className="board-hero-label-link"
              href={WATCH_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Watch on YouTube &rarr;
            </a>
          </div>
        </TornFrame>
      </div>
    </section>
  );
};

export default Hero;
